import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css"
import "../../../assets/css/admin/allAdmins.module.css"
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import { Link } from "react-router-dom";
import swal from "sweetalert";


const AllQuiz = () => {
  const [admins,setAdmins]=useState([])
  const getQuiz=()=>{
    axios.get(`${baseUrl}/quiz/all`)
    .then(res=>setAdmins(res.data))
    .catch(e=>console.log(e))
  }
  useEffect(()=>{
    getQuiz()
  },[])


  const deleteQuiz=(a)=>{
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        axios.post(`${baseUrl}/quiz/delete/?id=${a._id}&path=${a.path}`)
          .then(res=>{
            getQuiz()
              swal("Quiz has been deleted!", {
                  icon: "success",
                });
              }
          )
        
      } 
    });
  }

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        <div style={{ height: "30px" }}></div>
        <hr></hr>
        <div
          className="container"
          style={{ backgroundColor: "white", padding: "40px" }}
        >
                  <h4 className="mb-4"> All Quizzes</h4>
          <div>
            <table>
              <thead>
                <tr>
                  <td>SI</td>
                  <td>Exam</td>
                  <td>Subject</td>
                  <td>Start Date</td>
                  <td>Total Questions</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                {admins.length > 0 &&
                  admins.map((a, i) => (
                    <tr key={i}>
                      <td>{i+1}</td>
                      <td>{a.examName}</td>
                      <td>{a.subjectName}</td>
                      <td>{a.startDate}</td>
                      <td>{a.totalQuestions}</td>
                      <td>
                        <Link to={`/admin/exam/quiz/edit/${a._id}`}><button className="btn btn-success">Edit</button></Link>&nbsp;
                        <button onClick={()=>deleteQuiz(a)} className="btn btn-danger">Delete</button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AllQuiz;
